import React from 'react';
import { Spacer, Text } from '@ontruck/orc';

const flowTypes = {
  TYCOON_FLOW: 'Tycoon',
  MODERATION_QUEUE_FLOW: 'Moderation Queue',
  SAFE_NET_FLOW: 'Safety Net',
  CLOSE_TO_START: 'Close to start',
  TIME_TO_LAUNCH_SAFE_NET: 'Time to launch Safety Net',
  SHIPPER_CANCELS_EARLY: 'Shipper cancels early',
};

const JourneyLaunched = ({ changes: { drivers, flow_type }, ...props }) => {
  return (
    <Spacer {...props}>
      {drivers &&
        drivers.map((driver) => {
          return (
            <Text color="grey800" display="block">
              {driver}
            </Text>
          );
        })}
      {!!flowTypes[flow_type] && (
        <Text color="grey800" display="block">
          Flow type: {flowTypes[flow_type]}
        </Text>
      )}
    </Spacer>
  );
};

export default JourneyLaunched;
